import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react'
import GlobalButton from '../../../../../utility/globalButton/button'
import popupStyle from './../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import CreateVariableFields from './createVariableFields'
import { useSearchParams } from 'react-router-dom'
import { initialCustomVariableData, updatedCustomVariableData } from '../../../flowBuilderConstants'
import { UserContext, UserContextPayload } from '../../../../../../context/userContext'
import agent from '../../../../../../services/api'
import { updateChatbotCustomVariablePayload } from '../../../../../../models/axiosModel'
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore'
import { useGenericStore } from '../../../../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'

const CreateVariablePopup = () => {
    const [searchParams] = useSearchParams();
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)
    const createCustomVariablePayload = useFlowBuilderStore((state) => state.createCustomVariablePayload)
    const setCreateCustomVariablePayload = useFlowBuilderStore((state) => state.setCreateCustomVariablePayload)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const flagUpdateFieldData = useFlowBuilderStore((state) => state.flagUpdateFieldData)
    const GetCustomVariableListApi = useFlowBuilderStore((state) => state.GetCustomVariableListApi)

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const [tempExistingVariableData, setTempExistingVariableData] = useState<updateChatbotCustomVariablePayload>(existingCustomVariablePayload)

    let workflow_id = searchParams.get('workflow_id')

    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');

    const handleCreateFieldData = async () => {
        if (flagUpdateFieldData) {
            const payload = { 
                ...existingCustomVariablePayload,
                chatbot_custom_variable_fallback_value: existingCustomVariablePayload?.chatbot_custom_variable_fallback_value?.trim(),
            }

            setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: true } });
            const resp = await agent.updateChatbotCustomVariable.put(payload);
            if (resp.status) {
                showSuccess("Field Updated Successfully.")
                await GetCustomVariableListApi(workflow_id || "")
            }
            else {
                handleError(resp);
            }
            setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: false } });

            setFlagDataCollectionPopup(false)
            setFlagUpdateFieldData(false)
            setExistingCustomVariablePayload(updatedCustomVariableData)
        }
        else {
            const payload = { 
                ...createCustomVariablePayload,
                chatbot_custom_variable_fallback_value: createCustomVariablePayload?.chatbot_custom_variable_fallback_value?.trim(),
            }
            payload.chatbot_id = workflow_id || "";

            setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: true } });
            const resp = await agent.addChatbotCustomVariable.put(payload);
            if (resp.status) {
                showSuccess("Field Added Successfully.")
                await GetCustomVariableListApi(workflow_id || "")
            }
            else {
                handleError(resp);
            }
            setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: false } });

            setFlagDataCollectionPopup(false)
            setCreateCustomVariablePayload(initialCustomVariableData)
        }
    }

    const isCreateFieldDataDisabled = () => {
        if (flagUpdateFieldData) {
            // if ((existingCustomVariablePayload?.chatbot_custom_variable_name?.length == 0 || existingCustomVariablePayload?.chatbot_custom_variable_name?.trim() == "") || (JSON.stringify(existingCustomVariablePayload) == JSON.stringify(tempExistingVariableData))) {
            //     return true
            // } 
            const isNameEmpty = !existingCustomVariablePayload?.chatbot_custom_variable_name?.trim();
            const isSameName = existingCustomVariablePayload?.chatbot_custom_variable_name?.trim() === tempExistingVariableData?.chatbot_custom_variable_name?.trim();
            const isSameFallback = existingCustomVariablePayload?.chatbot_custom_variable_fallback_value?.trim() === tempExistingVariableData?.chatbot_custom_variable_fallback_value?.trim();

            if(isNameEmpty || (isSameName && isSameFallback)){
                return true;
            }
            return false
        }
        else {
            if ((createCustomVariablePayload?.chatbot_custom_variable_name?.length == 0 || createCustomVariablePayload?.chatbot_custom_variable_name?.trim() == "" || createCustomVariablePayload?.chatbot_custom_variable_fallback_value?.trim() == "")) {
                return true
            }
            return false
        }

    }

    const handleCancelFieldData = () => {
        if (flagUpdateFieldData) {
            setExistingCustomVariablePayload(tempExistingVariableData)
        }
        else {
            setCreateCustomVariablePayload(initialCustomVariableData)
        } 
        setFlagDataCollectionPopup(false);
        if(flagUpdateFieldData){
            setFlagUpdateFieldData(false);
        }
    }

    return (
        <Grid container direction={"column"} gap={"20px"} padding={"30px"} sx={{ zIndex: "1" }}>
            <Grid item sx={{ width: "100%" }} textAlign={"center"}>
                <span className={popupStyle.popupTitleStyle}>{flagUpdateFieldData ? "Update Field" : "Create New Field"}</span>
            </Grid>
            <Grid item>
                <Divider style={{ opacity: "0.3", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
            </Grid>
            <Grid item sx={{ width: "100%" }}>
                <Grid container direction={"column"} gap={"15px"}>
                    <CreateVariableFields />

                    <Grid item sx={{ width: "100%" }} mt={2}>
                        <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                            <Grid item>
                                <GlobalButton
                                    buttonText={"Cancel"}
                                    className='borderedButtonStyle'
                                    sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }}
                                    onClick={handleCancelFieldData}
                                />
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText={flagUpdateFieldData ? "Update" : "Create"}
                                    className='primaryButtonStyle'
                                    sx={{ minWidth: "130px" }}
                                    onClick={handleCreateFieldData}
                                    disabled={isCreateFieldDataDisabled()}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CreateVariablePopup
